import type { DataType } from '@platform/shared/rpc';

type RpcFilterParameter = { __type?: DataType; __array?: boolean; __v: any };
export type SerializableParameter = null | boolean | number | string | Date | Uint8Array;
export type CustomSqlSerializer = (startIndex: number) => [sql: string, args: SerializableParameter[]];

export type RpcFilters = (
    | [
          sql: string,
          parameters?: RpcFilterParameter | SerializableParameter | (RpcFilterParameter | SerializableParameter)[],
      ]
    | { op: 'OR' | 'AND'; children: RpcFilters }
)[];
export enum sqlOp {
    'OR' = 'OR',
    'AND' = 'AND',
}

export function sqlParam(val: any, type: DataType): RpcFilterParameter {
    return { __v: val, __type: type };
}
sqlParam.array = function (array: any[], type: DataType): RpcFilterParameter {
    return { __v: array, __type: type, __array: true };
};

export function sqlFilter(
    filter: TemplateStringsArray,
    ...args: (SerializableParameter | SerializableParameter[] | CustomSqlSerializer | RpcFilterParameter)[]
): RpcFilters[number] {
    let sql = '';
    const sqlArgs: (SerializableParameter | RpcFilterParameter)[] = [];
    filter.forEach((f, i) => {
        if (i > args.length - 1) {
            sql += f;
            return;
        }
        const arg = args[i];
        if (Array.isArray(arg)) {
            sql += f + arg.map((_, idx) => '$' + (sqlArgs.length + idx + 1)).join(',');
            sqlArgs.push(...arg);
        } else if (typeof arg === 'function') {
            const call = arg(sqlArgs.length + 1);
            sql += f + call[0];
            sqlArgs.push(...call[1]);
        } else {
            sql += f + '$' + (sqlArgs.length + 1);
            sqlArgs.push(arg);
        }
    });
    return sqlArgs.length ? (sqlArgs.length === 1 ? [sql, sqlArgs[0]] : [sql, sqlArgs]) : [sql];
}

export function sqlFilterIf(
    condition: unknown
): (
    filter: TemplateStringsArray,
    ...args: (SerializableParameter | SerializableParameter[] | CustomSqlSerializer | RpcFilterParameter | undefined)[]
) => RpcFilters {
    if (!condition) return () => [];
    return (filter, ...args) => [sqlFilter(filter, ...(args as SerializableParameter[]))];
}

export function sqlFilterLegacy(sql?: string | null | unknown): RpcFilters {
    if (!sql || typeof sql !== 'string') return [];
    return [[sql.replace(/_main_table_/g, 'main_table')]];
}

export function sqlFilterAnyProperty(filter: RpcFilters | string | null | undefined): RpcFilters {
    if (!filter) return [];
    if (Array.isArray(filter)) return filter;
    return sqlFilterLegacy(filter);
}
